@if (editAlertOptions().show) {
  <ncp-alert [(options)]="editAlertOptions">
    <alert-body>
      <span class="badge bg-danger p-2 ms-1 my-0">
        <h6 class="my-0">{{alertText}}</h6>
      </span>
    </alert-body>
  </ncp-alert>
}
